import { useSelector } from 'react-redux';
import { useAssetSchemaFF } from './useAssetSchemaFF';
import { systemSchemaSelector } from '@innovyze/lib_asset_schema_store';

export const useSystemTypes = () => {
	const { isValidSystemType } = useAssetSchemaFF();

	const systemTypes = useSelector(state => {
		return Object.values(systemSchemaSelector(state) ?? {}).filter(t =>
			isValidSystemType(t.id),
		);
	});

	return systemTypes;
};
